module.exports = __webpack_public_path__ + "static/media/arrow-left.b3d5c5ba.svg";